// src/pages/HomePage.js
import React, { useState } from 'react';
import Header from '../components/Header';
import TemplateSelector from '../components/TemplateSelector';
import URLForm from '../components/URLForm';

const HomePage = () => {
  const [selectedTemplate, setSelectedTemplate] = useState(null);

  return (
    <div>
      <Header title="Home" />
      <div style={{ padding: 16, marginTop: 24 }}>
        <TemplateSelector onSelect={setSelectedTemplate} />
        <URLForm selectedTemplate={selectedTemplate} />
      </div>
    </div>
  );
};

export default HomePage;
